import {DOCUMENT_APPROVE_ACCEPT, DOCUMENT_APPROVE_REJECT,} from '@/contants/base';

export async function checkApprove({commit}, {credential_token, token}) {
  const {errResponse, data: responseData} = await this.$axios.get(`v1/documents/check-advisor-approve/${token}/${credential_token}`);

  if (!errResponse && responseData.success) {
    const credential = responseData.data;
    commit('setCredential', credential);
    commit('setApprove', [DOCUMENT_APPROVE_ACCEPT, DOCUMENT_APPROVE_REJECT].includes(parseInt(credential.status)));
  }
}

export async function uploadFile({commit}, {payload, credentialToken}) {
  commit('setBtnLoading', true, {root: true});
  const response = await this.$axios.post(`v1/documents/upload-approve-file/${credentialToken}`, payload);
  commit('setIsUploadedFile', true);
  commit('setBtnLoading', false, {root: true});
  return response;
}

export async function checkTotalFail({commit}, document) {
  const check = !!document.document_approves.find(document_approve => {
    return document_approve.details.find(item => {
      return item => item.status === DOCUMENT_APPROVE_REJECT;
    });
  })

  commit('setTotalFail', check)
}

export async function applyDocument(_, id) {
  return await this.$axios.get(`v1/documents/approve/apply/${id}`);
}

export async function getAdvisorDetail(_, id) {
  return this.$axios.get(`v1/documents/approve/advisor/${id}`)
}
